import { render, staticRenderFns } from "./OnboardingView.vue?vue&type=template&id=5f8090f1&scoped=true&"
import script from "./OnboardingView.vue?vue&type=script&lang=js&"
export * from "./OnboardingView.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingView.vue?vue&type=style&index=0&id=5f8090f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8090f1",
  null
  
)

export default component.exports